import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ToastrConfig } from '../../../../config/toastr-config';
import { NotificationType } from '../../models/notification-type';

@Injectable()
export class NotificationService {
    constructor(private toastrService: ToastrService) {
    }

    public notify(message: string, title?: string, type?: NotificationType): void {
        const typeName = `toast-${ NotificationType[type].toLowerCase() }`;
        this.toastrService.show(message, title, ToastrConfig, typeName);
    }

    public showGenericError(): void {
        const genericErrorMessage = 'Something went wrong. Please try again later or contact administrator for further assistance.';
        this.notify(genericErrorMessage, 'Error', NotificationType.ERROR);
    }
}
